module.exports = __webpack_public_path__ + "img/P2.c991a41.svg";